import classnames from "classnames";
import React from "react";
import { ClassValue } from "classnames/types";

type IconName =
  | "fa-arrow-left"
  | "fa-arrow-right"
  | "fa-calendar"
  | "fa-fax"
  | "fa-phone"
  | "fa-plus"
  | "fa-times"
  | "fa-save"
  | "fa-credit-card";

export function SmallIcon(props: {
  name: IconName;
  className?: ClassValue;
  style?: React.CSSProperties;
}) {
  return (
    <span
      className={classnames("icon is-small", props.className)}
      style={props.style}
    >
      <i className={classnames("fa", props.name)} />
    </span>
  );
}
